var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"guides-to-bill","route":"/reports/billing-guides-to-bill","file-name":"guias-a-faturar.xlsx","period-label":"Período do atendimento","columns":_vm.columns,"default-days":360,"show-professional":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }